module.exports = __webpack_public_path__ + "img/share-icon-grey.fd7fde1c.svg";